async function guardarEvento(tipo, payload = {}, usuarioId = null) {
    try {
        await fetch("/eventos", {
            method:  "POST",
            headers: { "Content-Type": "application/json" },
            body:    JSON.stringify({ tipo, payload, usuarioId }),
        });
    } catch (_) {
        // silencioso — no interrumpir el flujo del usuario
    }
}



export function eventoVerContenido({ nombre, id, precio, categoria, usuarioId = null }) {
    guardarEvento("ver_servicio", { nombre, id, precio, categoria }, usuarioId);
}



export function eventoBusquedaRealizada({ termino, categoria, subcategoria, ciudad, ordenar, precioMax, idBusqueda, cantidadResultados, usuarioId = null }) {
    // Mismos campos que ya guarda el modelo Busqueda (ver busquedas.jsx en admin) — idBusqueda
    // enlaza este evento 1:1 con ese registro.
    const payload = { termino, categoria, subcategoria, ciudad, ordenar, precioMax, idBusqueda, cantidadResultados };
    guardarEvento("search_performed", payload, usuarioId);
    if (Number(cantidadResultados) === 0) guardarEvento("search_no_results", payload, usuarioId);
}



export function eventoAgregarAlCarrito({ nombre, id, precio, usuarioId = null }) {
    guardarEvento("agregar_al_carrito", { nombre, id, precio }, usuarioId);
}



export function eventoIniciarReserva({ nombre, id, precio, usuarioId = null }) {
    guardarEvento("iniciar_reserva", { nombre, id, precio }, usuarioId);
}



export function eventoCompraCompletada({ transaccionId, monto, usuarioId = null, descuentoPrimeraCompraAplicado = false, descuentoPrimeraCompra = 0 }) {
    guardarEvento("reserva_completada", { transaccionId, monto, descuentoPrimeraCompraAplicado, descuentoPrimeraCompra }, usuarioId);
}



// bloque: "vendedor" | "similares". idOrigen = servicio que se estaba viendo; idDestino = el que abrió.
export function eventoClickServicioRelacionado({ bloque, idOrigen, idDestino, posicion, usuarioId = null }) {
    guardarEvento("click_servicio_relacionado", { bloque, idOrigen, idDestino, posicion }, usuarioId);
}



export function eventoAgregarFavorito({ nombre, id, precio, usuarioId = null }) {
    guardarEvento("agregar_favorito", { nombre, id, precio }, usuarioId);
}



export function eventoRegistroCompletado({ metodo = "email", usuarioId = null }) {
    guardarEvento("registro_completado", { metodo }, usuarioId);
}



export function eventoLoginAttempt({ metodo = "email", usuarioId = null }) {
    guardarEvento("login_attempt", { metodo }, usuarioId);
}



export function eventoLoginSuccess({ metodo = "email", usuarioId = null }) {
    guardarEvento("login_success", { metodo }, usuarioId);
}



export function eventoLoginFailed({ metodo = "email", razon = "NA", usuarioId = null }) {
    guardarEvento("login_failed", { metodo, razon }, usuarioId);
}



export function eventoOnboardingStep({ step, usuarioId = null }) {
    guardarEvento("onboarding_step_completed", { step }, usuarioId);
}



export function eventoPonerEnRevision({ idServicio, categoria, usuarioId = null }) {
    guardarEvento("poner_en_revision", { idServicio, categoria }, usuarioId);
}



export function eventoSuscribirKlaviyo({ origen = "formulario", usuarioId = null }) {
    guardarEvento("suscribir_klaviyo", { origen }, usuarioId);
}



export function eventoClickDescargaApp({ plataforma, usuarioId = null }) {
    guardarEvento("click_descarga_app", { plataforma }, usuarioId);
}



export function eventoIniciarCreacionServicio({ usuarioId = null } = {}) {
    guardarEvento("iniciar_creacion_servicio", {}, usuarioId);
}



export function eventoPasoCreacionServicio({ paso, totalPasos, usuarioId = null }) {
    guardarEvento("paso_creacion_servicio", { paso, totalPasos }, usuarioId);
}



export function eventoClickLlamarAyuda({ numero, usuarioId = null }) {
    guardarEvento("click_llamar_ayuda", { numero }, usuarioId);
}



export function eventoClickWhatsAppAyuda({ usuarioId = null } = {}) {
    guardarEvento("click_whatsapp_ayuda", {}, usuarioId);
}
